import { Paper, Stack, Text } from '@sixui/ui';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type ICalloutProps = IContainerProps & {
  variant?: 'normal' | 'emphasized';
  icon?: React.ReactNode;
  title?: React.ReactNode;
  children?: React.ReactNode;
  actions?: React.ReactNode;
};

const styles = stylex.create({
  host: {
    padding: '1rem',
  },
  icon: {
    display: 'inline-block',
    marginRight: '0.5rem',
  },
});

export const Callout: React.FC<ICalloutProps> = ({
  sx,
  variant = 'normal',
  icon,
  title,
  children,
  actions,
}) => (
  <Paper
    as={Stack}
    sx={[styles.host, sx]}
    corner="md"
    surface={
      variant === 'emphasized'
        ? 'secondaryContainer'
        : 'surfaceContainerHighest'
    }
    gap={2}
  >
    {(title ?? children) ? (
      <Stack gap={2}>
        {title ? (
          <Text variant="title" size="md">
            {icon ? <span {...stylex.props(styles.icon)}>{icon}</span> : null}
            {title}
          </Text>
        ) : null}
        {children ? (
          <Text variant="body" size="md">
            {title ? null : icon ? (
              <span {...stylex.props(styles.icon)}> {icon}</span>
            ) : null}
            {children}
          </Text>
        ) : null}
      </Stack>
    ) : null}
    {actions ? (
      <Stack horizontal gap={2}>
        {actions}
      </Stack>
    ) : null}
  </Paper>
);
